var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WCImage',{attrs:{"imageClass":"barcode","imageSrc":_vm.src,"imageAlt":_vm.alt,"defaultImage":false}})}
var staticRenderFns = []

export { render, staticRenderFns }